function setSlideWidth(){
  $('.knoops-slide').each(function(){
  	var $parent_slider = $(this).closest('.knoops-slider');
    
    if( typeof $(this).closest('.knoops-slides').parent('.page-width')[0] !== 'undefined' ){
    	var $parent_slider = $(this).closest('.knoops-slides').parent('.page-width');
    }
    
    var currWindowSize = $(window).outerWidth();
    
    if( currWindowSize >= theme.breakpoints.widescreen && typeof $(this).data('widescreen-size') !== 'undefined' ){
      $(this).css('width', ( $($parent_slider).outerWidth() / $(this).data('widescreen-size') )  + 'px' );
      $('.knoops-slides').trigger('refresh.owl.carousel');
      return;
    }
    
    if( currWindowSize >= theme.breakpoints.large && typeof $(this).data('large-size') !== 'undefined' ){
      $(this).css('width', ( $($parent_slider).outerWidth() / $(this).data('large-size') )  + 'px' );
      $('.knoops-slides').trigger('refresh.owl.carousel');
      return;
    }
    
    if( currWindowSize >= theme.breakpoints.medium && typeof $(this).data('medium-size') !== 'undefined' ){
      $(this).css('width', ( $($parent_slider).outerWidth() / $(this).data('medium-size') )  + 'px' );
      $('.knoops-slides').trigger('refresh.owl.carousel');
      return;
    }

    $(this).css('width', $($parent_slider).outerWidth() + 'px' );
    $('.knoops-slides').trigger('refresh.owl.carousel');
    return;

    
  });
  
  
  $('.enable-slider-small').each(function(){
  	
    var currWindowSize = $(window).outerWidth();
    if( currWindowSize < theme.breakpoints.medium ){
      if( typeof $( this ).find('.grid--view-items').data('owl') === 'undefined' ||  $( this ).find('.grid--view-items').data('owl') === false ){
        
        var $owl_instruction = {
          margin: 0,
          loop: false,
          items:1,
          dots: false,
          nav: true
        };
        
        $( this ).find('.grid--view-items').owlCarousel( $owl_instruction );
        $( this ).find('.grid--view-items').data('owl', true);    
        $( this ).find('.grid--view-items').trigger('change_owl_carousel');
      }else{
      	$( this ).find('.grid--view-items').trigger('refresh.owl.carousel');
        $( this ).find('.grid--view-items').trigger('change_owl_carousel');
       // $( this ).find('.grid--view-items').trigger('changed.owl.carousel');
      }
      
    }else{
    	$(this).find('.grid--view-items').trigger('destroy.owl.carousel');
      	$(this).find('.grid--view-items').data('owl', false);
    } 
    
  });

 
  $('.enable-slider-responsive').each(function(){
  	
    var currWindowSize = $(window).outerWidth();

    $(this).find('.grid--view-items').trigger('destroy.owl.carousel');
    $(this).find('.grid--view-items').data('owl', false);

    $(this).find('.grid__item').each(function(){
      if( typeof $(this).data('originalClass') === 'undefined' ){
        $(this).data('originalClass', $(this).prop('class') );
        $(this).prop('class', 'grid__item' );
      }
    });
    
    var grid_total = $(this).data('products-per-row');
    var grid_mob_total = $(this).data('products-per-row-mob');
    
    if( currWindowSize < theme.breakpoints.medium ){

      var $owl_instruction = {
          margin: 0,
          loop: false,
          items:grid_mob_total,
          dots: false,
          nav: true
        };
       if( grid_mob_total >= $(this).find('.grid__item').length ){
         $owl_instruction.nav = false;
         $(this).find('.kc-icons').addClass('inactive');
         $(this).removeClass('nav-active');
       }else{
         $(this).find('.kc-icons').removeClass('inactive');
         $(this).addClass('nav-active');
       }        
        $( this ).find('.grid--view-items').owlCarousel( $owl_instruction );
        $( this ).find('.grid--view-items').data('owl', true);    
        $( this ).find('.grid--view-items').trigger('change_owl_carousel');
      
    }else{
     
        var $owl_instruction = {
          margin: 0,
          loop: false,
          items:grid_total,
          dots: false,
          nav: true
        };

       if( grid_total >= $(this).find('.grid__item').length ){
         $owl_instruction.nav = false;
         $(this).find('.kc-icons').addClass('inactive');
         $(this).removeClass('nav-active');
       }else{
         $(this).find('.kc-icons').removeClass('inactive');
         $(this).addClass('nav-active');
       }   
      
        $( this ).find('.grid--view-items').owlCarousel( $owl_instruction );
        $( this ).find('.grid--view-items').data('owl', true);    
        $( this ).find('.grid--view-items').trigger('change_owl_carousel');

    } 

    let caro = this;
    $(window).resize( function(){
      $(caro).trigger('refresh.owl.carousel');
    });
    
  });

  
  $('.enable-press-slider').each(function(){
  	
    var currWindowSize = $(window).outerWidth();

    $(this).trigger('destroy.owl.carousel');
    $(this).data('owl', false);
    $(this).addClass('owl-carousel');
    
    $(this).find('.kpl-image').each(function(){
      if( typeof $(this).data('originalClass') === 'undefined' ){
        $(this).data('originalClass', $(this).prop('class') );
        $(this).prop('class', 'kpl-image' );
      }
    });
    
    var grid_total = 12 / $(this).data('desktop-size');
    var grid_mob_total = 12 / $(this).data('mobile-size');
    var parentContainer = $(this).closest('.enable-press-list-slider');

    var animation_enabled = $( this ).data('animated') !== null && $( this ).data('animated') == true ? true : false;
    
    if( currWindowSize < theme.breakpoints.medium ){

      var $owl_instruction = {
          margin: 0,
          loop: false,
          items:grid_mob_total,
          dots: false,
          nav: true,
          loop: true
        };
       if( animation_enabled ){
         $owl_instruction.autoplay = true;
         $owl_instruction.autoplayTimeout = $( this ).data('animated-speed') !== null ? $( this ).data('animated-speed') * 1000 : 1000;
       }
       if( grid_mob_total >= $(this).find('.kpl-image').length ){
         $owl_instruction.nav = false;
         $(parentContainer).find('.kc-icons').addClass('inactive');
         $(this).removeClass('nav-active');
       }else{
         $(parentContainer).find('.kc-icons').removeClass('inactive');
         $(this).addClass('nav-active');
       }          
        $( this ).owlCarousel( $owl_instruction );
        $( this ).data('owl', true);    
        $( this ).trigger('change_owl_carousel');
      
    }else{
     
        var $owl_instruction = {
          margin: 0,
          loop: false,
          items:grid_total,
          dots: false,
          nav: true,
          loop: true
        };
       if( animation_enabled ){
         $owl_instruction.autoplay = true;
         $owl_instruction.autoplayTimeout = $( this ).data('animated-speed') !== null ? $( this ).data('animated-speed') * 1000 : 1000;
       }        
       if( grid_total >= $(this).find('.kpl-image').length ){
         $owl_instruction.nav = false;
         $(parentContainer).find('.kc-icons').addClass('inactive');
         $(this).removeClass('nav-active');
       }else{
         $(parentContainer).find('.kc-icons').removeClass('inactive');
         $(this).addClass('nav-active');
       }
      
        $( this ).owlCarousel( $owl_instruction );
        $( this ).data('owl', true);    
        $( this ).trigger('change_owl_carousel');

    } 
    
  });

  $('.enable-stockist-slider').each(function(){
  	
    var currWindowSize = $(window).outerWidth();

    $(this).trigger('destroy.owl.carousel');
    $(this).data('owl', false);
    $(this).addClass('owl-carousel');
    
    $(this).find('.kpl-image').each(function(){
      if( typeof $(this).data('originalClass') === 'undefined' ){
        $(this).data('originalClass', $(this).prop('class') );
        $(this).prop('class', 'kpl-image' );
      }
    });
    
    var grid_total = 12 / $(this).data('desktop-size');
    var grid_mob_total = 12 / $(this).data('mobile-size');
    var parentContainer = $(this).closest('.enable-stockist-list-slider');

    
    if( currWindowSize < theme.breakpoints.medium ){

      var $owl_instruction = {
          margin: 0,
          loop: false,
          items:grid_mob_total,
          dots: false,
          nav: true
        };
       if( grid_mob_total >= $(this).find('.kpl-image').length ){
         $owl_instruction.nav = false;
         $(parentContainer).find('.kc-icons').addClass('inactive');
         $(this).removeClass('nav-active');
       }else{
         $(parentContainer).find('.kc-icons').removeClass('inactive');
         $(this).addClass('nav-active');
       }          
        $( this ).owlCarousel( $owl_instruction );
        $( this ).data('owl', true);    
        $( this ).trigger('change_owl_carousel');
      
    }else{
     
        var $owl_instruction = {
          margin: 0,
          loop: false,
          items:grid_total,
          dots: false,
          nav: true
        };

       if( grid_total >= $(this).find('.kpl-image').length ){
         $owl_instruction.nav = false;
         $(parentContainer).find('.kc-icons').addClass('inactive');
         $(this).removeClass('nav-active');
       }else{
         $(parentContainer).find('.kc-icons').removeClass('inactive');
         $(this).addClass('nav-active');
       }
      
        $( this ).owlCarousel( $owl_instruction );
        $( this ).data('owl', true);    
        $( this ).trigger('change_owl_carousel');

    } 
    
  });
  
}

$(document).ready(function(){
	setSlideWidth();
});

$(window).resize(function(){
	setSlideWidth();
});


$('.knoops-slider').each(function(){

  var $owl_instruction = {
    margin: 0,
    loop: false,
    autoWidth: true,
    items:1,
    dots: false,
    nav: true
  };
  
  $(this).find('.knoops-slides').owlCarousel($owl_instruction);
  
});

$(window).load(function(){
	var knoops_slider = $(this).closest('.knoops-slider');
  $(knoops_slider).each( function(){
  	var active_slide = $(knoops_slider).find('.knoops-slide').eq(0);

    if( typeof $(this).data('original-class') === 'undefined') {
      $(this).data('original-class', $(this).attr('class') );
    }
    $(this).attr('class', $(this).data('original-class') );
    if( typeof $(active_slide).data('colour-scheme') !== 'undefined' ){

      $(this).addClass($(active_slide).data('colour-scheme'));
      return false;
    }

  });

});


$('document').ready(function(){
	var knoops_slider = $(this).closest('.knoops-slider');
  $(knoops_slider).each( function(){
  	var active_slide = $(knoops_slider).find('.knoops-slide').eq(0);

    if( typeof $(this).data('original-class') === 'undefined') {
      $(this).data('original-class', $(this).attr('class') );
    }
    $(this).attr('class', $(this).data('original-class') );
    if( typeof $(active_slide).data('colour-scheme') !== 'undefined' ){

      $(this).addClass($(active_slide).data('colour-scheme'));
      return false;
    }

  });

});

$('body').on('changed.owl.carousel', '.knoops-slides', function(e){
  
    var target_index = e.property.value;  
	var knoops_slider = $(this).closest('.knoops-slider');
	
  	var disable_button = 'disable-button';  	
  	var active_slide = $( knoops_slider).find('.owl-item.active .knoops-slide');
	var index_collection = [];
  	if($.isNumeric(target_index)) { 
    	var active_slide = $(knoops_slider).find('.owl-item').eq(target_index).find('.knoops-slide'); // Getting target slide HTML
      	index_collection.push(target_index);
    }
  
    var knoops_controls = $(knoops_slider).find('.knoops-controls');
    $(knoops_controls).find('.kc-icons').removeClass(disable_button);  

  	$(active_slide).each(function(){
      if( typeof $(knoops_slider).data('original-class') === 'undefined') {
        $(knoops_slider).data('original-class', $(knoops_slider).attr('class') );
      }
      $(knoops_slider).attr('class', $(knoops_slider).data('original-class') );
      if( typeof $(this).data('colour-scheme') !== 'undefined' ){

        $(knoops_slider).addClass($(this).data('colour-scheme'));
        return false;
      }

    });
	
  	if( typeof $( knoops_slider).find('.owl-nav')[0] !== 'undefined' ){
  	  var owl_nav = $( knoops_slider).find('.owl-nav');
      if( typeof $( owl_nav ).find('.disabled')[0] !== 'undefined' ){
        if ( $( owl_nav ).find('.disabled').hasClass('owl-prev') ){
        	$(knoops_controls).find('.kc-prev').addClass('disable-button');
        }
        if ( $( owl_nav ).find('.disabled').hasClass('owl-next') ){
        	$(knoops_controls).find('.kc-next').addClass('disable-button');
        }        
      }
      
  	}

    //console.log( index_collection );
  
   //initMaps();

});

$('body').on('changed.owl.carousel', '.grid--view-items', function(){
    $(this).trigger('change_owl_carousel');
});

$('body').on('change_owl_carousel', '.grid--view-items', function(){
   	var knoops_slider = $(this).closest('.enable-slider-small');
    var knoops_controls = $(knoops_slider).find('.knoops-controls');
   	var disable_button = 'disable-button';  	
    $(knoops_controls).find('.kc-icons').removeClass(disable_button);    
  	if( typeof $( knoops_slider).find('.owl-nav')[0] !== 'undefined' ){
  	  var owl_nav = $( knoops_slider).find('.owl-nav');console.log('hi');
      if( typeof $( owl_nav ).find('.disabled')[0] !== 'undefined' ){
        if ( $( owl_nav ).find('.disabled').hasClass('owl-prev') ){
        	$(knoops_controls).find('.kc-prev').addClass('disable-button');
        }
        if ( $( owl_nav ).find('.disabled').hasClass('owl-next') ){
        	$(knoops_controls).find('.kc-next').addClass('disable-button');
        }        
      }
      
  	} 
});

$('body').on('initialised.owl.carousel', '.knoops-slides', function(e){
  
    var target_index = e.property.value;  
	var knoops_slider = $(this).closest('.knoops-slider');
  	
  	var active_slide = $(this).find('.owl-item.active .knoops-slide');
    if($.isNumeric(target_index)) { 
    	var active_slide = $(knoops_slider).find('.owl-item').eq(target_index).find('.knoops-slide'); // Getting target slide HTML
    }
  
    $(active_slide).each(function(){
      if( typeof $(knoops_slider).data('original-class') === 'undefined') {
        $(knoops_slider).data('original-class', $(knoops_slider).attr('class') );
      }
      $(knoops_slider).attr('class', $(knoops_slider).data('original-class') );
      if( typeof $(this).data('colour-scheme') !== 'undefined' ){

        $(knoops_slider).addClass($(this).data('colour-scheme'));
        return false;
      }
    
    });
 
});

$('body').on('to.owl.carousel', '.knoops-slides', function( e ){
 var active_slide = $(this).find('.owl-item.active .knoops-slide');
  if( typeof $(active_slide).data('slide-identifier') !== 'undefined') {
  	var slide_id = $(active_slide).data('slide-identifier');
    $('a[href*="@slide"]').removeClass('slide-selected');
    $('a[href*="@slide::'+slide_id+'"]').addClass('slide-selected');
  }
  
});

$('body').on('click', '.kc-icons', function(){
	var knoops_slider = $(this).closest('.knoops-slider');
  	var knoops_slides = $(knoops_slider).find('.knoops-slides');
  	
  	if( $(this).hasClass('kc-prev') ){
  		$(knoops_slides).trigger('prev.owl.carousel');	   
    }else if( $(this).hasClass('kc-next') ){
    	$(knoops_slides).trigger('next.owl.carousel');	
    }
});

$('body').on('click', '.kc-icons', function(){
	var knoops_slider = $(this).closest('.enable-slider-small');
  	var knoops_slides = $(knoops_slider).find('.grid--view-items');
  	
  	if( $(this).hasClass('kc-prev') ){
  		$(knoops_slides).trigger('prev.owl.carousel');	   
    }else if( $(this).hasClass('kc-next') ){
    	$(knoops_slides).trigger('next.owl.carousel');	
    }
});

$('body').on('click', '.kc-icons', function(){
	var knoops_slider = $(this).closest('.enable-slider-responsive');
  	var knoops_slides = $(knoops_slider).find('.grid--view-items');
  	
  	if( $(this).hasClass('kc-prev') ){
  		$(knoops_slides).trigger('prev.owl.carousel');	   
    }else if( $(this).hasClass('kc-next') ){
    	$(knoops_slides).trigger('next.owl.carousel');	
    }
});

$('body').on('click', '.kc-icons', function(){
	var knoops_slider = $(this).closest('.knoops-press-list-banner-inner');
  	var knoops_slides = $(knoops_slider).find('.enable-press-slider');
  	
  	if( $(this).hasClass('kc-prev') ){
  		$(knoops_slides).trigger('prev.owl.carousel');	   
    }else if( $(this).hasClass('kc-next') ){
    	$(knoops_slides).trigger('next.owl.carousel');	
    }
});

$('body').on('click', '.kc-icons', function(){
	var knoops_slider = $(this).closest('.knoops-stockist-banner-inner');
  	var knoops_slides = $(knoops_slider).find('.enable-stockist-slider');
  	
  	if( $(this).hasClass('kc-prev') ){
  		$(knoops_slides).trigger('prev.owl.carousel');	   
    }else if( $(this).hasClass('kc-next') ){
    	$(knoops_slides).trigger('next.owl.carousel');	
    }
});


$('*[href*="@slide"]').on('click',function(e){
	e.preventDefault();
    var slide_info = $(this).attr('href').split('::');
  	var url = location.href;
  	history.replaceState(null,null,url);
	var slide_target = $('.knoops-slide[data-slide-identifier="'+slide_info[1]+'"]');
  	if( typeof slide_target !== 'undefined' ){
      	var target_owl = $(slide_target).closest('.knoops-slides');
  		var target_owl_item = $(slide_target).closest('.owl-item');
      	var slide_anchor = $(target_owl).closest('.shopify-section').find('.anchor');
      	if( typeof $(slide_anchor)[0] !== 'undefined' ){
      	   $(slide_anchor)[0].scrollIntoView();
      	}
      	//console.log(slide_target);
      	var target_index = $(target_owl).find('.owl-item').index( target_owl_item );
      	//console.log( target_index );
      	$(target_owl).trigger('to.owl.carousel', target_index);
  	}
});